import React, { Suspense, useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router';
import Loading from 'components/Loading';
import ProtectedRoute from './ProtectedRoute';
import { CountryContext } from 'contexts/CountryContext';
import UnProtectedRoute from "./UnprotectedRoute"
import RouteNames from './routeNames';

const Home = React.lazy(() => import('pages/Home'));
const SignUp = React.lazy(() => import('pages/SignUp'));
// const RegisterSuccess = React.lazy(() => import('pages/Signup/RegisterSuccess'));
const SignIn = React.lazy(() => import('pages/SignIn'));
const EmailConfirmation = React.lazy(() => import('pages/EmailConfirmation'));
const EmailConfirmed = React.lazy(() => import('pages/EmailConfirmation/Confirmed'));
const ForgotPassword = React.lazy(() => import('pages/ForgotPassword'));
const ChangePassword = React.lazy(() => import('pages/ForgotPassword/ChangePassword'));

//User
const UserSettings = React.lazy(() => import('pages/UserSettings'));

//WorkReply
const WorkReply = React.lazy(() => import('pages/WorkReply'));
const EditReply = React.lazy(() => import('pages/WorkReply/EditReply'));


//WorkLeads
const WorkLeads = React.lazy(() => import("pages/WorkLead"))
const EmailVerifier = React.lazy(() => import("pages/WorkLead/EmailVerifier"))
const EmailSender = React.lazy(() => import("pages/WorkLead/EmailSender"))


//WorkMail
const WorkMail = React.lazy(() => import("pages/WorkMail"))
const Inbox = React.lazy(() => import("pages/WorkMail/inbox"))
const EmailView = React.lazy(() => import("pages/WorkMail/EmailView"))

//WorkMeet
const WorkMeet = React.lazy(() => import("pages/WorkMeet"))
const CalendarView = React.lazy(() => import("pages/WorkMeet/Calendar"))
const CalendarSchedule = React.lazy(() => import("pages/WorkMeet/Calendar/Schedule"))
const MeetingScheduled = React.lazy(() => import("pages/WorkMeet/Calendar/Scheduled"))
const BookingTable = React.lazy(() => import("pages/WorkMeet/Bookings/BookingTable"))

//WorkContent
const WorkContent = React.lazy(() => import("pages/WorkContent"))
const WorkContentGenerator = React.lazy(() => import("pages/WorkContent/generator"));
const WorkContentProjects = React.lazy(() => import("pages/WorkContent/projects"));
const WorkContentPinned = React.lazy(() => import("pages/WorkContent/PinnedContents"));

//WorkEncrypt
const WorkEncrypt = React.lazy(() => import("pages/WorkEncrypt"));
const WorkEncryptViewSecret = React.lazy(() => import("pages/WorkEncrypt/viewSecret"));
const WorkEncryptViewAllSecret = React.lazy(() => import("pages/WorkEncrypt/secrets"));

//WorkReview
const WorkReview = React.lazy(() => import("pages/WorkReview"));
const WorkReviewAddRating = React.lazy(() => import("pages/WorkReview/userAddReview/addRating"));
const WorkReviewAddFeedback = React.lazy(() => import("pages/WorkReview/userAddReview/addFeedback"));
const WorkReviewAddReviewOnOtherPlatform = React.lazy(() => import("pages/WorkReview/userAddReview/addReviewOnOtherPlatform"));
const WorkReviewThankYou = React.lazy(() => import("pages/WorkReview/userAddReview/thankYou"));

//WorkIterate
const WorkIterate = React.lazy(() => import("pages/WorkIterate"));
const WorkIterateFunnel = React.lazy(() => import("pages/WorkIterate/Funnel/index"));

//WorkFlow
const WorkFlow = React.lazy(() => import("pages/WorkFlow"));
const GoogleServiceAuthPage = React.lazy(() => import("pages/WorkFlow/components/googleAuthPage"));

//page not found
const PageNotFound = React.lazy(() => import("pages/404"));

export default function Routes({ language, country }) {
	return (
		<Suspense fallback={<Loading />}>
			<Switch>
				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/${RouteNames.google.serviceAuth}`} >
					<GoogleServiceAuthPage language={language} />
				</ProtectedRoute>

				{/*****************/}

				<Route exact path="/">
					<Redirect to={`/${country}`} />
				</Route>

				<UnProtectedRoute exact path={`/:country/${RouteNames.auth.signIn}`}>
					<SignIn />
				</UnProtectedRoute>

				<UnProtectedRoute exact path={`/:country/${RouteNames.auth.signUp}`}>
					<SignUp />
				</UnProtectedRoute>

				<UnProtectedRoute exact path={`/:country/${RouteNames.auth.emailConfirmation}`}>
					<EmailConfirmation />
				</UnProtectedRoute>

				<UnProtectedRoute exact path={`/:country/${RouteNames.auth.emailConfirmed}`}>
					<EmailConfirmed />
				</UnProtectedRoute>

				<UnProtectedRoute exact path={`/:country/${RouteNames.auth.forgotPassword}`}>
					<ForgotPassword />
				</UnProtectedRoute>

				<UnProtectedRoute exact path={`/:country/${RouteNames.auth.changePassword}`}>
					<ChangePassword />
				</UnProtectedRoute>

				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country${RouteNames.home}`} >
					<Home language={language} />
				</ProtectedRoute>

				{/* User */}
				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country/${RouteNames.user.settings}`} >
					<UserSettings language={language} />
				</ProtectedRoute>

				{/* WorkReply */}
				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country/${RouteNames.workreply.home}`}>
					<WorkReply language={language} />
				</ProtectedRoute>

				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country/${RouteNames.workreply.add}`} >
					<EditReply isEdit={false} language={language} />
				</ProtectedRoute>

				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country/${RouteNames.workreply.edit}/:id`} >
					<EditReply isEdit={true} language={language} />
				</ProtectedRoute>

				{/* WorkLeads */}
				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country/${RouteNames.workleads.home}`}>
					<WorkLeads language={language} />
				</ProtectedRoute>

				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country/${RouteNames.workleads.emailVerifier}`}>
					<EmailVerifier language={language} />
				</ProtectedRoute>

				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country/${RouteNames.workleads.emailSender}`}>
					<EmailSender language={language} />
				</ProtectedRoute>

				{/* WorkMail */}
				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country/${RouteNames.workmail.home}`}>
					<WorkMail language={language} />
				</ProtectedRoute>

				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country/${RouteNames.workmail.emailInbox(':inboxId')}`}>
					<Inbox language={language} />
				</ProtectedRoute>

				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country/${RouteNames.workmail.emailView(':inboxId', ':emailId')}`}>
					<EmailView language={language} />
				</ProtectedRoute>

				{/* WorkMeet */}

				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country/${RouteNames.workmeet.home}`}>
					<WorkMeet language={language} />
				</ProtectedRoute>

				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country/${RouteNames.workmeet.calendarView(':calendarId')}`}>
					<CalendarView language={language} />
				</ProtectedRoute>

				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country/${RouteNames.workmeet.bookingTable}`}>
					<BookingTable language={language} />
				</ProtectedRoute>

				<Route exact path={`/:country/${RouteNames.workmeet.schedule(':path')}`}>
					<CalendarSchedule language={language} />
				</Route>

				<Route exact path={`/:country/${RouteNames.workmeet.scheduled(':meetingId')}`}>
					<MeetingScheduled language={language} />
				</Route>

				{/* WorkContent */}

				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country/${RouteNames.workcontent.home}`}>
					<WorkContent language={language} />
				</ProtectedRoute>

				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country/${RouteNames.workcontent.generator(':projectId')}`}>
					<WorkContentGenerator language={language} />
				</ProtectedRoute>

				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country/${RouteNames.workcontent.projects}`}>
					<WorkContentProjects language={language} />
				</ProtectedRoute>

				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country/${RouteNames.workcontent.pinned}`}>
					<WorkContentPinned language={language} />
				</ProtectedRoute>

				{/* WorkEncrypt */}

				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country/${RouteNames.workencrypt.home}`}>
					<WorkEncrypt language={language} />
				</ProtectedRoute>

				<Route exact path={`/:country/${RouteNames.workencrypt.viewSecret(':linkId')}`}>
					<WorkEncryptViewSecret language={language} />
				</Route>

				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country/${RouteNames.workencrypt.secret}`}>
					<WorkEncryptViewAllSecret language={language} />
				</ProtectedRoute>

				{/* WorkReview */}

				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country/${RouteNames.workreview.home}`}>
					<WorkReview language={language} />
				</ProtectedRoute>

				<Route exact path={`/:country/${RouteNames.workreview.rating(':linkId')}`}>
					<WorkReviewAddRating language={language} />
				</Route>

				<Route exact path={`/:country/${RouteNames.workreview.feedback(':linkId')}`}>
					<WorkReviewAddFeedback language={language} />
				</Route>

				<Route exact path={`/:country/${RouteNames.workreview.review(':linkId')}`}>
					<WorkReviewAddReviewOnOtherPlatform language={language} />
				</Route>

				<Route exact path={`/:country/${RouteNames.workreview.thankYou(':linkId')}`}>
					<WorkReviewThankYou language={language} />
				</Route>

				{/* WorkIterate */}

				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country/${RouteNames.workiterate.project(':projectId', ':toolId')}`}>
					<WorkIterate language={language} />
				</ProtectedRoute>

				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country/${RouteNames.workiterate.tactic(':projectId', ':toolId', ':tacticId')}`}>
					<WorkIterate language={language} />
				</ProtectedRoute>

				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country/${RouteNames.workiterate.tacticsFunnel(':projectId', ':funnelId', ':service')}`}>
					<WorkIterateFunnel language={language} />
				</ProtectedRoute>

				{/* WorkFlow */}

				<ProtectedRoute allowedRoles={["user", "workdeputy"]} exact path={`/:country/${RouteNames.workflow.home(':name')}`}>
					<WorkFlow language={language} />
				</ProtectedRoute>

				{/* Page Not Found */}

				<Route path={`/${country}/404`} >
					<PageNotFound language={language} />
				</Route>

				<Redirect to={`/${country}/404`} />
			</Switch>
		</Suspense >
	);
}
